import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import { Form, Button, Checkbox, Row, Col, Icon } from 'antd';
import Register from './Register';
import { Inputs } from '../../helper/form/input'
import CONFIG from '../../config';
import { url } from '../../helper/image';
const FormItem = Form.Item;

export class LogIn extends Component {

  static propTypes = {
    authentification: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };

  constructor(props) {
    super(props)
    this.state = {
      email: '',
      email_valid: false,
      password: '',
      password_valid: false,
    }
  }

  handleSubmit = () => {
    if(this.state.email_valid && this.state.password_valid)
      this.props.actions.login(this.state.email, this.state.password)
  }

  useSSO() {
    if (this.props.fromPresence) localStorage.setItem("ssoFromPresence", "yes")
    window.location.href = 
      `${CONFIG.SSO.url}/login?service=${encodeURIComponent(CONFIG.SSO.service)}${this.props.fromPresence ? "event/presence" : ""}`
  }
  
  render() {
    return (
      <div>
        <Row>
            <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{span: 18, offset: 3 }} lg={{ span: 14, offset: 5 }} className="login">
              <div className="login-student-ynov">
                <h2 style={{ textTransform: 'uppercase', fontSize: '20px', fontWeight: 'bold'}}>etudiant ynov</h2>
                <Button
                  className="ant-btn ui-btn" style={{ float: "none"}} icon="arrow-right" onClick={this.useSSO.bind(this)}>
                  Se connecter avec son compte
                </Button>
              </div>
              <div id="guest-form" className="authentification-log-in">
                <h2 style={{ textTransform: 'uppercase', fontSize: '18px', marginBottom:'10px'}}><span style={{fontWeight: 'bold'}}>profil invité</span> - { this.state.register ? "s'inscrire" : "se connecter" } <span style={{ fontSize: 12, float: "right" }}><Icon type="right-circle" theme="outlined" /><a style={{color: "#23b2a4" }} href="#guest-form" onClick={()=>{ this.setState(({ register }) => ({ register: !register }))}}> { this.state.register ? "Se connecter" :  "S'inscrire" } </a></span></h2>

              { this.state.register ? 
                <Register />
              :
                <Form className="login-form form-front">
                  <Inputs.Email
                    value={this.state.email}
                    onCheck={(email_valid) => this.setState({ email_valid })}
                    onChange={(email) => this.setState({ email })}
                    checkOnChange
                    required
                  />
                  <Inputs.Password
                    value={this.state.password}
                    placeholder="Mot de passe"
                    onCheck={(password_valid) => this.setState({ password_valid })}
                    onChange={(password) => this.setState({ password })}
                    checkOnChange
                    required
                  />
                  <FormItem>
                    <a style={{color: "#23b2a4"}} href="#guest-form" onClick={()=>this.setState({ register : true })}> Pas encore de compte ? </a>
                    {/*<Link className="login-form-forgot" to="/auth/recovery-password">Mot de passe oublié</Link>*/}
                    <Row>
                      <Button
                        htmlType="submit"
                        onClick={this.handleSubmit}
                        disabled={!(this.state.email_valid && this.state.password_valid)}
                        loading={this.props.authentification.status.login.pending}
                        className="ant-btn ui-btn">
                        Se connecter
                      </Button>
                    </Row>
                  </FormItem>
                </Form>
              }
              </div>
            </Col>
        </Row>
      </div>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    authentification: state.authentification,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LogIn);


// WEBPACK FOOTER //
// ./src/features/authentification/LogIn.js